import useAuth from 'app/hooks/useAuth';

import { collection, getFirestore, onSnapshot } from 'firebase/firestore';
import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { userPinterestStateAtom } from '../atom';

const usePinterest = () => {
  const setUserPinterests = useSetRecoilState(userPinterestStateAtom);

  const { user } = useAuth();

  useEffect(() => {
    const uid = user?.uid;
    if (!uid) return;

    const unsubscribePinterest = onSnapshot(
      collection(getFirestore(), 'userData', uid, 'pinterest'),
      (snapshot) => {
        let nPinterests = [];
        snapshot.forEach((doc) => {
          nPinterests.push({ ...doc.data(), id: doc.id });
        });
        setUserPinterests(nPinterests);
      }
    );

    return () => {
      unsubscribePinterest();
    };
  }, [user?.uid]);

  return null;
};

export default usePinterest;
